
const search = document.querySelector('.icon-search');
const options = {
  rootMargin: '20px'
}
const callback = async (entries, observer) => {
    if (entries[0].intersectionRatio === 0) return;
    import('@swc-packages-internal/iconset/stories/icons-demo.js');
    import('@swc-packages-internal/icons-workflow/stories/icon-manifest.js').then(({iconManifest}) => {
        search.icons = iconManifest;
    });
    observer.disconnect();
}
const observer = new IntersectionObserver(callback, options);
observer.observe(search);
